// extracted by mini-css-extract-plugin
module.exports = {"imgSection":"BindingResult_imgSection__3_7jw","messageSection":"BindingResult_messageSection__fhrEb"};